import CallHistoryItem from "./CallHistoryItem";

const CallHistory = ({clickHandler, clickAllowed, history = [], callUuid}) => {
    const itemClickHandler = (index) => () => clickHandler(index);

    return <div className="location-card-list">
        {history.map((data,index) => <CallHistoryItem clickAllowed={clickAllowed}
                                                      clickHandler={itemClickHandler(index)}
                                                      history={data}
                                                      key={callUuid + "_call_history_" + index}/> )}
    </div>
};
export default CallHistory;
